module.exports = __webpack_public_path__ + "img/externalServer.ea3dcc2.svg";